import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function TabMenu(props) {
  const location = useLocation();
  const { handleChange } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{ padding: '5px 0px' }}>
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}
        sx={{
          color: "#000!important",
          fontSize: "15px!important",
          fontFamily: "AvenirNext!important",
          fontWeight: "600!important",
          '& .MuiButton-endIcon': {
            marginTop: '-5px'
          }
        }}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Dropdown
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem 
          selected={location.pathname === `/contracts/active-contracts`}
          value={`/contracts/active-contracts`}
          to={`/contracts/active-contracts`}
          component={Link}
          onClick={(e) => { 
            handleClose();                          
            handleChange("status", "active")
          }} disableRipple>
          Active Contracts
        </MenuItem>

        <MenuItem 
          selected={location.pathname === `/contracts/terminated`}
          value={`/contracts/terminated`}
          to={`/contracts/terminated`}
          component={Link}
          onClick={(e) => { 
            handleClose();                          
            handleChange("status", "terminated")
          }} disableRipple>
          Terminated
        </MenuItem>

        <MenuItem 
          selected={location.pathname === `/contracts/closed`}
          value={`/contracts/closed`}
          to={`/contracts/closed`}
          component={Link}
          onClick={(e) => { 
            handleClose();                          
            handleChange("status", "closed")
          }} disableRipple>
          CLOSED
        </MenuItem>

        <MenuItem 
          selected={location.pathname === `/contracts/need-approval`}
          value={`/contracts/need-approval`}
          to={`/contracts/need-approval`}
          component={Link}
          onClick={(e) => { 
            handleClose();                          
            handleChange("status", "terminated")
          }} disableRipple>
          Need Approval
        </MenuItem>

        <MenuItem 
          selected={location.pathname === `/contracts/tasks`}
          value={`/contracts/tasks`}
          to={`/contracts/tasks`}
          component={Link}
          onClick={(e) => { 
            handleClose();                          
            handleChange("status", "closed")
          }} disableRipple>
          Tasks
        </MenuItem>
      </StyledMenu>
    </div>
  );
}